import React, {Component} from 'react';
import {connect} from 'react-redux';
import MyAccountEditForm from './forms/MyAccountEditForm';
import {fetchUser, updateUser} from './thunks';

class MyAccountEdit extends Component {
    componentWillMount() {
        this.props.fetchUser(this.props.match.params.userId);
    }

    handleEditMyAccountSubmit(formProps) {
        this.props.updateUser(formProps);
    }

    render() {
        return (
            this.props.loading !== true && (
                <MyAccountEditForm
                    loading={this.props.loading}
                    initialValues={this.props.initialValues}
                    formValues={this.props.formValues}
                    handleFormSubmit={this.handleEditMyAccountSubmit.bind(this)}
                    passwordUpdatedAt={this.props.passwordUpdatedAt}
                />
            )
        );
    }
}

const mapStateToProps = (state, props) => ({
    initialValues: {
        id: state.myaccount.user.id,
        name: state.myaccount.user.name,
        email: state.myaccount.user.email,
        current_password: '',
        new_password: '',
        new_password_repeat: ''
    },
    formValues: state.form.MyAccountEditForm,
    loading: state.layout.ajaxCallsInProgress > 0,
    passwordUpdatedAt: state.auth.user.password_updated_at
});

export default connect(
    mapStateToProps,
    {
        fetchUser,
        updateUser
    }
)(MyAccountEdit);



// WEBPACK FOOTER //
// ./src/containers/myaccount/MyAccountEdit.jsx